import { BottleSodaIcon } from './BottleSodaIcon';

/**
 * author: Michael Richins
 * id D938FAC2-CC48-431D-8019-FA41677470DD
 * name bottle-soda
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-soda.svg
 * tags
 * - Food / Drink 
 */
export const BottleCokeIcon = BottleSodaIcon;
export default BottleCokeIcon